export default "__VITE_ASSET__DHmNHZX8__"